import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useAnnouncementTypeDropdownQuery } from '../../../../api';
import { useLanguage } from '../../../../contexts/LanguageContext';

const norm = (s) => (s == null ? '' : String(s).trim().toLowerCase());

const AnnouncementTypeDropdown = ({
  selectedType, // ana type ID
  value,        // seçili alt tip (string veya ID olabilir)
  id,           // seçili ID (deprecated, value kullanılmalı)
  onChange,
  placeholder = 'Seçiniz',
  disabled = false,
}) => {
  const { getCurrentLanguageId } = useLanguage();
  const currentLanguageId = getCurrentLanguageId();
  
  const typeNum = selectedType != null ? Number(selectedType) : null;
  const skip = typeNum == null || Number.isNaN(typeNum);
  const languageId = getCurrentLanguageId();

  const { data, isLoading, isFetching, isError } =
    useAnnouncementTypeDropdownQuery({ type: typeNum ?? undefined, languageId: currentLanguageId }, { skip });

  const options = useMemo(() => {
    if (!Array.isArray(data)) return [];
    return data.map((x) => ({
      label: x.announcementType,
      value: x.id,  // ID'yi value olarak kullan (dil değişse de ID sabit kalır)
      id: x.id
    }));
  }, [data]);

  // Seçili değeri bul - id prop'u veya value prop'u kullanılabilir
  const selectedValue = useMemo(() => {
    const currentId = id ?? value;
    if (currentId == null) return null;
    
    // Eğer value string ise (eski kullanım), ID'ye çevir
    if (typeof currentId === 'string') {
      const found = options.find(o => norm(o.label) === norm(currentId));
      return found ? found.value : null;
    }
    
    // ID ise direkt kullan
    return currentId;
  }, [id, value, options]);

  const handleChange = (e) => {
    const selectedId = e.value ?? null;
    const selectedOption = options.find(o => o.value === selectedId);
    
    onChange?.({
      value: selectedOption?.label ?? '',
      id: selectedId
    });
  };

  return (
    <Dropdown
      value={selectedValue}
      options={options}
      onChange={handleChange}
      placeholder={placeholder}
      className="w-full"
      disabled={disabled || skip || isLoading || isFetching || isError}
      showClear
      filter
    />
  );
};

export default AnnouncementTypeDropdown;
